import { parse, stringify } from 'query-string';
import { isBooleanFilterKey, isFilterKey, isSearchFilterKey } from 'shared/constants/sorting-values';
import { isValidSortingValue } from './is-valid-sorting-value';

export const replaceQueryParams = (searshQuery: string) => {
  const parsedQuery = parse(searshQuery);

  const queryKeys = Object.keys(parsedQuery);

  const sortKey = queryKeys.find((item) => item.includes('sort'));

  if (sortKey) {
    const sortValues = (parsedQuery[sortKey] as string).split(',');

    if (isValidSortingValue(sortValues[0])) {
      parsedQuery.order = sortValues[1];
      parsedQuery.orderTerms = sortValues[0];
    }

    delete parsedQuery[sortKey];
    delete parsedQuery['offset'];
  }

  const filterKeys = queryKeys.filter((item) => item.includes('filter'));

  for (const filterKey of filterKeys) {
    const filterValues = (parsedQuery[filterKey] as string).split('||');

    if (isFilterKey(filterValues[0])) {
      if (isBooleanFilterKey(filterValues[0])) {
        parsedQuery[filterValues[2]] = 'true';
      }

      if (isSearchFilterKey(filterValues[0])) {
        parsedQuery[filterValues[0]] = filterValues[2];
      }
    }

    delete parsedQuery[filterKey];
    delete parsedQuery['offset'];
  }

  return stringify(parsedQuery);
};
